import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse, HttpResponseBase } from '@angular/common/http';
import { Observable, Subscriber } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AbortablePromise, Rates } from '@eg-brs/eg.js.ratelimit';
import { ContextService, RateLimitService } from 'src/app/services';

@Injectable()
export class RateLimitInterceptor implements HttpInterceptor {

  constructor(private rateLimitService: RateLimitService, private context: ContextService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.startsWith(this.context.serviceUrl)) {
      return next.handle(request);
    }

    return new Observable<HttpEvent<any>>((subscriber: Subscriber<HttpEvent<any>>) => {
      const queue = this.rateLimitService.queue;

      const queued = queue.enqueue<void>(() => {
        const req = next.handle(request)
          .pipe(
            tap((resp: HttpEvent<any>) => {
              if (resp instanceof HttpResponse) {
                const rates = this.getRates(resp);
                if (rates) queue.rates = rates;
              }
            },
              (resp: HttpErrorResponse) => {
                const rates = this.getRates(resp);
                if (rates) queue.rates = rates;
              })
          );

        const sub = req.subscribe(subscriber);
        const p = new Promise<void>((resolve, reject) => { }) as AbortablePromise<void>; //we don't use the result from this promise

        p.abort = () => {
          sub.unsubscribe();
        }
        return p;
      });

      return function unsubscribe() {
        queued.abort();
      };
    });
  }

  private getRates(resp: HttpResponseBase): Rates {
    const limits = this.getXRatelimitGroup(resp, 'limit');
    const remaining = this.getXRatelimitGroup(resp, 'remaining');

    return this.removeEmpty({ limits, remaining });
  }

  private getXRatelimitGroup(resp: HttpResponseBase, group: string) {
    const second = this.getXRatelimit(resp, `x-ratelimit-${group}-second`);
    const minute = this.getXRatelimit(resp, `x-ratelimit-${group}-minute`);
    const hour = this.getXRatelimit(resp, `x-ratelimit-${group}-hour`);

    return this.removeEmpty({ second, minute, hour });
  }

  private getXRatelimit(resp: HttpResponseBase, name: string): number {
    const value = resp.headers.get(name);
    if (!value) return null;
    const num = Number(value);
    return !isNaN(num) ? num : null;
  }

  private removeEmpty(obj: any) {
    const r = Object.entries(obj)
      .filter(([_, v]) => v != null)
      .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
    return Object.keys(r).length ? r : null;
  }
}
